import React from 'react';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Java Code Executor</h3>
            <p>Compile and run Java code online instantly. No installation required.</p>
          </div>
          <div className="footer-section">
            <h4>Tools</h4>
            <ul>
              <li><a href="/java-online-compiler">Online Java Compiler</a></li>
              <li><a href="/run-java-code-online">Run Java Code Online</a></li>
              <li><a href="/java-playground">Java Playground</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Resources</h4>
            <ul>
              <li><a href="/java-online-compiler">Java Tutorial</a></li>
              <li><a href="/run-java-code-online">Code Examples</a></li>
              <li><a href="/java-playground">Practice Problems</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 Java Code Executor. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
